export default "__VITE_ASSET__BI9y0AGn__"